export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9702.cb2fed73.jpg";